<template>
  <div class="sm:flex flex-row text-white uppercase w-full pb-0 h-auto sm:px-20 py-2 items-center sm:py-5 bg-gradient-to-b from-black via-red-800 sm:to-red-500 to-black">
    <div class="hidden lg:flex flex-col flex-1 items-start text-3xl gap-10">
      <div class="flex flex-col uppercase">
        <mdn-text isInverse class="uppercase">A internet móvel</mdn-text>
        <mdn-text isInverse class="uppercase">mais rapida do brasil.</mdn-text>
      </div>
      <div class="flex flex-row w-full gap-3">
        <div class="flex flex-1 justify-end">
          <img class="w-32" src="../assets/images/app-icons/speedtest.svg" alt="Speedtest" style="filter: invert(1)" />
        </div>
        <div class="flex flex-1 flex-col justify-start">
          <mdn-text isInverse class="text-sm uppercase">A internet móvel</mdn-text>
          <mdn-text isInverse class="text-sm uppercase">mais rápida do Brasil,</mdn-text>
          <mdn-text isInverse class="text-sm uppercase">confirmada pelo speedtest*</mdn-text>
        </div>
      </div>
    </div>

    <div class="hidden sm:flex flex-col flex-1 items-center">
      <div class="flex flex-row gap-5">
        <div class="flex flex-col">
          <img src="https://mondrian.claro.com.br/brands/horizontal/inverse/claro-controle.svg" alt="Claro Controle" />
          <div id="bannerFullDataBlock" class="flex flex-row text-8xl justify-center">
            <mdn-text class="font-extrabold" isInverse>{{offer?.data.full}}</mdn-text>
            <mdn-text isInverse>GB</mdn-text>
          </div>
        </div>

        <div class="flex flex-col items-center">
          <div class="flex-1 border-r-2"></div>
          <mdn-text isInverse class="text-2xl font-bold text-yellow-400">+</mdn-text>
          <div class="flex-1 border-r-2"></div>
        </div>

        <div class="flex flex-col">
          <div class="flex flex-row gap-3">
            <div id="bannerMainDataBlock" class="flex flex-col">
              <mdn-text isInverse class="text-3xl">
                <span class="font-extrabold">{{offer?.data.main}}</span>GB
              </mdn-text>
              <mdn-text isInverse class="text-xs">de internet</mdn-text>
            </div>
            <mdn-text id="bannerBonusPlusSign" isInverse class="text-3xl" v-if="offer?.data?.bonus">+</mdn-text>
            <div id="bannerBonusDataBlock" class="flex flex-col" v-if="offer?.data?.bonus">
              <mdn-text isInverse class="text-3xl">
                <span class="font-extrabold">{{offer.data.bonus}}</span>GB
              </mdn-text>
              <mdn-text isInverse class="text-xs">de bônus</mdn-text>
            </div>
          </div>

          <mdn-text id="bannerAppsDataBlock" isInverse class="text-lg tracking-widest"><strong>+ {{ offer?.data.apps }}GB</strong> para os apps:</mdn-text>
          <div class="flex flex-row gap-2 flex-wrap min-h-4 w-52 justify-start items-start">
            <BrandIconMdn
              v-for="(app, index) in filterClaroIcon(offer?.apps.limited, false)"
              :brandName="app.icon"
              :key="'app-icon-' + index"
              class="w-8"
            />
          </div>

          <mdn-text isInverse class="text-lg tracking-widest">App ilimitado:</mdn-text>
          <div class="flex flex-row gap-2 flex-wrap w-52 justify-start items-start">
            <BrandIconMdn
              v-for="(app, index) in filterClaroIcon(offer?.apps.unlimited, false)"
              :brandName="app.icon"
              :key="'app-icon-' + index"
              class="w-8"
            />
          </div>

        </div>
      </div>

      <div class="flex border-b-2 w-full mt-4 h-full"></div>

      <div class="flex flex-row w-full h-full items-center flex-1 gap-3">
        <div
          class="flex flex-row flex-1 items-center gap-4 justify-center h-full"
        >
          <p class="text-4xl font-bold text-yellow-400">+</p>
          <BrandIconMdn
              v-for="(app, index) in filterClaroIcon(offer?.benefit.includedApps, true)"
              :brandName="app.icon"
              :key="'app-icon-' + index"
              class="w-9"
            />
          <div>
            <mdn-text isInverse class="uppercase">APPS Claro</mdn-text>
          </div>
        </div>

        <div class="flex flex-col border-r-2 h-20"></div>

        <div class="flex flex-col flex-1 gap-1">
          <div class="flex flex-row items-center gap-2">
            <div class="flex flex-col items-center">
              <mdn-text isInverse class="text-xl">por</mdn-text>
              <mdn-text class="text-3xl text-yellow-400">R$</mdn-text>
            </div>
            <div id="bannerPriceRecorrenciaBlock" class="flex flex-row text-yellow-400">
              <mdn-text class="text-yellow-400 text-7xl font-bold">{{offer?.price.adesao.main}}</mdn-text>
              <mdn-text class="text-yellow-400 text-7xl">,</mdn-text>
              <div class="flex flex-col">
                <mdn-text class="text-5xl text-yellow-400">{{offer?.price.adesao.cents}}</mdn-text>
                <mdn-text class="text-2xl text-yellow-400">/ mês</mdn-text>
              </div>
            </div>
          </div>
          <mdn-text isInverse class="uppercase">no crédito</mdn-text>
        </div>
      </div>

      <div class="flex">
        <Button id="bannerButton" global class="mt-3" @click="onContratar">Contratar</Button>
      </div>
    </div>

    <div class="flex sm:hidden lg:flex flex-col flex-1 items-center">
      <img
        src="../assets/images/illustration/dia_dos_pais_controle.png"
        alt="Claro Controle"
      />
    </div>
  </div>

</template>

<script>
import { MdnText, Button } from 'mondrian-vue'
import OfferCommon from '../pages/1-step/Offer/OfferCommon'
import BrandIconMdn from '../components/BrandIconMdn.vue'

export default {
  name: 'Banner',
  components: { MdnText, Button, BrandIconMdn },
  extends: OfferCommon,
  props: {
    offer: Object
  },
  methods: {
    filterClaroIcon: (apps, only) =>
      apps
        ?.filter(app => only
          ? app.name.toUpperCase().includes('CLARO')
          : !app.name.toUpperCase().includes('CLARO')
        ),
    async onContratar () {
      this.$emit('onContratar', { ...this.offer })
    }
  }
}
</script>
